import { combineReducers } from 'redux'
import { OpportunitiesAppState, OpportunitiesCategoriesState } from 'interfaces/opportunities'
import { createFilterCategoryReducer } from 'reducers/globalReducer'
import { OPPORTUNITIES_PAGE } from 'constants/pages'
import { createLoadingReducer } from 'helpers/reducerHelpers'
import { SocialInsightUid } from 'interfaces/socialInsights'
import { ToggleSocialInsightLike, TOGGLE_SOCIAL_INSIGHT_LIKE } from 'actions/socialInsightsActions'
import { TOP_CATEGORY_ID } from 'constants/meta'

const likingSocialInsightUids = createLoadingReducer<SocialInsightUid, ToggleSocialInsightLike>(
  TOGGLE_SOCIAL_INSIGHT_LIKE,
  (a) => a.payload.params.socialInsightUid,
)


const opportunitiesAppReducer = combineReducers<OpportunitiesAppState>({
  likingSocialInsightUids,
  categories: combineReducers<OpportunitiesCategoriesState>({
    selectedId: createFilterCategoryReducer(OPPORTUNITIES_PAGE, TOP_CATEGORY_ID),
  }),
})

export default opportunitiesAppReducer
